<div class="product-info-section">
  <div class="row">
    <div class="col-md-3 col-xl-4" *ngIf="product">
      <div class="img-wrap">
        <img 
          [src]="getProductImage() | imagePath" 
          class="img-fluid d-block" 
          [alt]="getProductTitle()" />
      </div>
    </div>
    <div class="col-md-9 col-xl-8">
      <div>
        <h2 class="light-head mt-4 hide-small">
          {{ getProductTitle() }}
        </h2>
        
        <!-- Product Details -->
        <div class="product-details" *ngIf="product">
          <div class="product-sku">
            <!-- <strong>Part No:</strong> {{ getProductSku() }} -->
          </div>

          <!-- Pricing Information (if not hidden) -->
          <div class="product-pricing" *ngIf="!is_hide_cost && hasPricing()">
            <div class="price-display">
              <span class="unit-price">
                {{ product.uae_retail_price || product.price | currency:'$ ' }}
                <span class="small-txt">(each)</span>
              </span>
              <span class="set-price">
                {{ (product.uae_retail_price || product.price) * 4 | currency: '$ ' }}
                <span class="small-txt">(set of 4)</span>
              </span>
            </div>
          </div>
          
          <!-- Additional Information -->
          <!-- <ul class="detailsul" *ngIf="deliveryDate">
            <li>
              All prices inclusive of Duty &amp; VAT.
            </li>
            <li>
              Delivered by <u>{{ getFormattedDeliveryDate() }}</u>
            </li>
          </ul> -->
        </div>
      </div>
    </div>
  </div>
</div>
